import { useState } from 'react'

import MenuOptions from './MenuOptions/MenuOptions'
import SupportFooter from './SupportFooter/SupportFooter'
import * as Styles from './styles'

const SideBarMenu = ({
  options = [],
  currentPath,
  selectedReturnPortal,
  returnPortals,
  onChangeReturnPortal,
  supportDashboardUrl,
}) => {
  const [showMenu, setShowMenu] = useState(false)

  return (
    <Styles.SideBarMenuContainer onMouseEnter={() => setShowMenu(true)} onMouseLeave={() => setShowMenu(false)}>
      <MenuOptions
        options={options}
        currentPath={currentPath}
        selectedReturnPortal={selectedReturnPortal}
        returnPortals={returnPortals}
        onChangeReturnPortal={onChangeReturnPortal}
        showMenu={showMenu}
      />
      <SupportFooter supportDashboardUrl={supportDashboardUrl} showMenu={showMenu} />
    </Styles.SideBarMenuContainer>
  )
}

export default SideBarMenu
